import styled from '@emotion/styled'
import GreenCheck from 'assets/icons/green-check.svg'
import UserGroupIcon from 'assets/icons/nucleo/18px_user-group.svg'
import { unifiedColors } from 'styles/colors'
import { media } from 'styles/responsive'
import { theme, themeUtils } from 'styles/theme'

interface TopBarProps {
  $backgroundColor?: keyof typeof unifiedColors.surface
}

export const StyledGroupsLogo = styled(UserGroupIcon)`
  width: 16px;
  height: 18px;
`

export const StyledCheckoutLayoutContainer = styled.div`
  height: 100vh;
  ${media.maxWidth.md} {
    padding: 16px;
  }
  ${media.minWidth.md} {
    width: 944px;
    padding-top: 24px;
    margin: auto;
  }
`

export const ColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const OrderConfirmationLogo = styled(GreenCheck)`
  width: 64px;
  margin: 24px 0;
`

export const PreviewTopBar = styled.div<TopBarProps>`
  width: 100%;
  display: flex;
  align-items: center;
  padding: 16px;
  background: ${({ $backgroundColor }) =>
    $backgroundColor
      ? unifiedColors.surface[$backgroundColor]
      : unifiedColors.shadow.tertiary};
  justify-content: center;
  gap: 8px;
  position: sticky;
  top: 0;
  z-index: 103;
`

export const PreviewTitle = styled.h3`
  ${themeUtils.bodySmallSemiBold};
  color: ${theme.palette.label.default};
`

export const TwoColumnContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column-reverse;
  z-index: 1;
  ${media.minWidth.md} {
    flex-direction: row;
    justify-content: space-between;
  }
`

export const FormColumnContainer = styled.div`
  width: 100%;
  ${media.minWidth.md} {
    width: 464px;
  }
  padding-bottom: 16px;
`

export const CheckoutTitle = styled.h3`
  margin-bottom: 20px;
`

export const CheckoutSubTitle = styled.h4`
  margin-bottom: 20px;
`

export const SuccessContainer = styled.div`
  display: flex;
  flex-direction: column;
  & > * {
    margin-bottom: 16px;
  }
  & > :last-child {
    margin-top: 20px;
  }
`

export const StrongWord = styled.strong`
  font-weight: ${themeUtils.fontWeights.large};
`

export const FlexContainer = styled.div`
  display: flex;
  align-items: center;
  & > * {
    margin-right: 12px;
  }
`
export const IconContainer = styled.div`
  width: 24px;
`
